import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["for"]

import { CheckboxItemInterface } from '@/types';
import { computed } from 'vue';

interface PropsInterface {
  items?: Array<CheckboxItemInterface> | null;
  title: string;
  className?: string | null;
  updateItem: (id: string, checked: boolean) => void;
  cancel: () => void;
  save: () => void;
  dirty: boolean;
  loading?: boolean;
  disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckboxForm',
  props: {
    items: {},
    title: {},
    className: {},
    updateItem: { type: Function },
    cancel: { type: Function },
    save: { type: Function },
    dirty: { type: Boolean },
    loading: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const loadingOrSaving = computed(() => props.loading && (!props.items || props.items.length === 0));

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_FormCard = _resolveComponent("FormCard")!

  return (_openBlock(), _createBlock(_component_FormCard, {
    title: __props.title,
    dirty: __props.dirty,
    cancel: __props.cancel,
    save: __props.save,
    "content-class-name": "start",
    "class-name": __props.className
  }, {
    form: _withCtx(() => [
      (loadingOrSaving.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
              return _createVNode(_component_Skeleton, {
                key: n,
                width: "100%",
                height: "24px"
              })
            }), 64))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("form", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "field"
          }, [
            _createVNode(_component_Checkbox, {
              id: item.name,
              modelValue: item.checked,
              "onUpdate:modelValue": ($event: any) => ((item.checked) = $event),
              value: item.checked,
              binary: true,
              disabled: loadingOrSaving.value || __props.disabled,
              onChange: ($event: any) => (__props.updateItem(item.id, item.checked as boolean))
            }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "value", "disabled", "onChange"]),
            _createElementVNode("label", {
              class: "font-bold",
              for: item.name
            }, _toDisplayString(item.name), 9, _hoisted_2)
          ]))
        }), 128)),
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["title", "dirty", "cancel", "save", "class-name"]))
}
}

})